import { LitElement, mailcheck } from '@hh/global.js'

class KlaviyoNewsletter extends LitElement {
  static properties = {
    openModal: { type: Boolean, attribute: 'open-modal' },
  }

  constructor() {
    super()
    this.form = this.querySelector('form')
    if (!this.form) return

    this.klaviyoCompanyId = this.form.querySelector(
      '[name="klaviyo-company-id"]'
    ).value
    this.klaviyoListId = this.form.querySelector(
      '[name="klaviyo-list-id"]'
    ).value

    this.submitButton = this.querySelector('[type="submit"]')
    this.successBanner = this.querySelector('.js-success-banner')
    this.errorBanner = this.querySelector('.js-error-banner')
    this.emailSuggestion = this.querySelector('.js-email-suggestion')
  }

  connectedCallback() {
    this.form?.addEventListener('submit', this.submitForm.bind(this))
  }

  submitForm(evt) {
    evt.preventDefault()
    this.hideStatus()
    this.submitButton?.setAttribute('disabled', true)
    if (!this.klaviyoCompanyId || !this.klaviyoListId) {
      this.adminError()
    }

    const formData = new FormData(this.form)
    const email = formData.get('contact[email]')

    mailcheck.run({
      email,
      suggested: (suggestion) => {
        this.emailSuggestion.querySelector('.js-email').innerHTML = `${suggestion.address}@<strong>${suggestion.domain}</strong>`
        this.emailSuggestion.removeAttribute('hidden')
      },
      empty: () => {
        if (this.openModal) {
          this.handleOpenModal(email)
        } else {
          this.createSubscription(email)
        }
      }
    })
  }

  handleOpenModal(email) {
    const modal = document.querySelector('hh-newsletter-modal')
    if (modal?.openWithValue) {
      modal.disabled = false
      modal.openWithValue(email)
    } else {
      this.createSubscription()
    }
  }

  async createSubscription(email) {
    window.dataLayer = window.dataLayer || [];
    const url = `https://a.klaviyo.com/client/subscriptions/?company_id=${this.klaviyoCompanyId}`

    const options = {
      method: 'POST',
      headers: { revision: '2023-06-15', 'content-type': 'application/json' },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            list_id: this.klaviyoListId,
            custom_source: 'Homepage footer signup form',
            email: email,
          },
        },
      }),
    }

    try {
      const res = await fetch(url, options)
      if (!res.ok) throw new Error('Klaviyo API error')
      this.showSuccess()

      const emailInput = this.form.querySelector('input[name="contact[email]"]')
      emailInput.value = ''

      window.dataLayer.push({
        'event': 'newsletter_sign_up',
        'page_position': 'Footer'
      })

    } catch (error) {
      console.error(error)
      this.showError()
    } finally {
      this.submitButton?.removeAttribute('disabled')
    }
  }

  adminError() {
    console.error(
      'Klaviyo Company ID or List ID not set in theme editor settings'
    )
    this.submitButton.setAttribute('disabled', true)
    this.showError()
  }

  showSuccess() {
    this.successBanner?.removeAttribute('hidden')
  }

  showError() {
    this.errorBanner?.removeAttribute('hidden')
  }

  hideStatus() {
    this.successBanner?.setAttribute('hidden', true)
    this.errorBanner?.setAttribute('hidden', true)
    this.emailSuggestion?.setAttribute('hidden', true)
  }
}

customElements.define('hh-klaviyo-newsletter', KlaviyoNewsletter)
